<template>
    <div class="flex flex-col items-center justify-items-center lg:px-64 md:px-32 sm:px-16 px-3 mb-40">
        <h2 class="mt-16 mb-10 tracking-wider font-semibold text-center text-3xl">{{ $route.params.title }}</h2>
        <tailwind-image
            v-if="linkExists(0)"
            :link="links[0]"
            aspect-ratio="7/12"
            class="w-full"
        ></tailwind-image>
        <div class="mt-5">
            Für die Firma HEWI und ihre Ausstellung SMXL wurde im Bauwerk Köln die innere Struktur umorganisiert. Zentrales Element der Neustrukturierung sind vier verfahrbare Präsentationsboxen – die sogenannten „Schubladen“. Die Prototypen der Entwürfe von BRT, UN Studio, Delugan-Meissl, Deffner-Voitländer, ARUP und Graft wurden in den vier verfahrbaren „Schubladen“ auf großformatigen Wand- und Türelementen präsentiert. Gezeigt wurden die neuesten Produktentwicklungen der Firma HEWI in einer exklusiven Präsentation. Die entstehende Schaufenstersituation bildet dabei einen optisch einheitlichen aber inhaltlich differenzierten Hintergrund für die einzelnen Produktinnovationen. Neben den Präsentationsboxen beinhaltet die Ausstellung zwei mit HEWI-Produkten ausgekleidete Eventboxen, die als Sketch- und Book-Lounge die Möglichkeit zur Diskussion und Interaktion bieten. Das Konzept der verfahrbaren Boxen und Schubladen dient so auch als unverwechselbares Kommunikationswerkzeug für den Event-Standort Bauwerk Köln.
        </div>
        <div class="grid grid-cols-2 w-full mt-5">
            <tailwind-image
                v-if="linkExists(1)"
                :link="links[1]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
            <tailwind-image
                v-if="linkExists(2)"
                :link="links[2]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
        </div>
        <tailwind-image
            v-if="linkExists(3)"
            :link="links[3]"
            aspect-ratio="7/12"
            class="w-full my-5"
        ></tailwind-image>
        <div class="grid grid-cols-2 w-full mt-5">
            <tailwind-image
                v-if="linkExists(4)"
                :link="links[4]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
            <tailwind-image
                v-if="linkExists(5)"
                :link="links[5]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
        </div>
        <tailwind-image
            v-if="linkExists(6)"
            :link="links[6]"
            aspect-ratio="7/12"
            class="w-full my-5"
        ></tailwind-image>
        <div class="grid grid-cols-2 w-full mt-5">
            <tailwind-image
                v-if="linkExists(7)"
                :link="links[7]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
            <tailwind-image
                v-if="linkExists(8)"
                :link="links[8]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
        </div>
        <tailwind-image
            v-for="iLink in allRemainingLinks"
            :key="'VueKey' + iLink"
            :link="iLink"
            aspect-ratio="7/12"
            class="w-full my-5"
        ></tailwind-image>

        <span class="mt-5 w-full text-left">
            <p class="font-semibold">Entwurf und Realisierung</p>
            <p>Markus Holzbach mit Formorf</p>
        </span>

    </div>
</template>
<script>
import TailwindImage from '@/components/TailwindImage';


export default {
    components: {
        TailwindImage,
    },
    props: {},
    data ()
    {
        return {
            links: [
                require( '@/assets/img/pc/_DSC1157.jpg' ),
                require( '@/assets/img/pc/_DSC0804.jpg' ),
                require( '@/assets/img/pc/_DSC1155.jpg' ),
                require( '@/assets/img/pc/IMG_4702.jpg' ),
                require( '@/assets/img/pc/_DSC1159.jpg' ),
                require( '@/assets/img/pc/_DSC1160.jpg' ),
                require( '@/assets/img/pc/hewi_3.jpg' ),
                require( '@/assets/img/pc/IMG_4683.jpg' ),
                require( '@/assets/img/pc/IMG_4684.jpg' ),
                require( '@/assets/img/pc/IMG_4690.jpg' ),
            ],
        };
    },
    methods: {
        linkExists ( index )
        {
            return index in this.links;
        }
    },
    created () { },
    computed: {
        allRemainingLinks ()
        {
            if ( !this.linkExists( 9 ) )
            {
                return [];
            } else
            {
                return this.links.slice( 9 );
            }
        }
    }
};
</script>